import {defineStore} from 'pinia'

export const useReservationStore = defineStore('reservationStore', {
    state: () => ({
        reservationInfo: {},
        rentType: -1,
        amounts: 0,
        rentBeginTime: '',
        rentEndTime: '',
        rentAccessories: [],
        estimatedAmount: 0,
        rentGroup: '',
        needBeConfirm: true,
    }),
    getters: {
        getReservationInfo: (state) => {
            return state.reservationInfo
        },
        getRentType: (state) => {
            return state.rentType
        },
        getAmounts: (state) => {
            return state.amounts
        },
        getRentBeginTime: (state) => {
            return state.rentBeginTime
        },
        getRentEndTime: (state) => {
            return state.rentEndTime
        },
        getAccessories: (state) => {
            return state.rentAccessories
        },
        getEstimatedAmount: (state) => {
            return state.estimatedAmount
        },
        getRentGroup: (state) => {
            return state.rentGroup
        },
        getNeedBeConfirm: (state) => {
            return state.needBeConfirm
        },
    },
    actions: {
        updateReservationInfo(spaceItem) {
            this.reservationInfo = spaceItem
        },
        updateRentType(rentType) {
            this.rentType = rentType
        },
        updateAmounts(amounts) {
            this.amounts = amounts
        },
        updateRentBeginTime(date) {
            this.rentBeginTime = date
        },
        updateRentEndTime(date) {
            this.rentEndTime = date
        },
        updateAccessories(accessories) {
            this.rentAccessories = accessories
        },
        updateEstimatedAmount(estimatedAmount) {
            this.estimatedAmount = estimatedAmount
        },
        updateRentGroup(rentGroup) {
            this.rentGroup = rentGroup
        },
        updateNeedBeConfirm(needBeConfirm) {
            this.needBeConfirm = needBeConfirm
        },
        cleanReservationData() {
            this.reservationInfo = {}
            this.rentType = -1
            this.amounts = 0
            this.rentBeginTime = ''
            this.rentEndTime = ''
            this.rentAccessories = []
            this.estimatedAmount = 0
            this.rentGroup = ''
            this.needBeConfirm = true
        }
    },
    persist: {
        storage: persistedState.localStorage
    }
})

